
<span v-if="this.isToday || this.isYesterday">{{formatDate}}</span>
<time v-else>{{formatDate}}</time>
